import React, { useEffect, useState } from "react";
import { bool, shape, arrayOf } from "prop-types";
import { push, replace } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import * as i18nUtils from "util/i18n";
import { connect, useDispatch } from "react-redux";
import { selectors as environmentSelectors, actions as environmentActions } from "reducers/environment";
import { actions as modalActions } from "reducers/modal";

import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import ErrorPopup from "pages/_components/ErrorPopup";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { isIOS } from "react-device-detect";
import EnvironmentStepper from "../_components/EnvironmentStepper";
import Uploader from "../_components/Uploader";
import EnvironmentHelpSlide from "../_components/EnvironmentHelpSlide";
import { useThubanDocs } from "./hooks/useThubanDocs";
import { useHistoricData } from "../hooks/useHistoricData";

const FORM_ID = "environment.step.documentation";
const PAGE_ID = "StepDocumentation";

const StepDocumentation = ({ isMobile, documentationBackup, documentationRequest, fetching }) => {
    const dispatch = useDispatch();
    const { status: documentationRequestStatus, error: documentationRequestError } = documentationRequest;
    const [error, setError] = useState("");
    const [helpIsVisible, setHelpIsVisible] = useState(false);

    const {
        thubanCodeEstatuto,
        thubanCodeModificacionesEstatuto,
        thubanCodeActasDesignacion,
        thubanCodeActasDistribucion,
        thubanCodeBalanceActual,
        thubanCodeBalanceAnterior,
        thubanCodeActasGobiernoActual,
        thubanCodeActasGobiernoAnterior,
        thubanCodeVentas,
        thubanCodeIvaMesActual,
        thubanCodeIvaSegundoMes,
        thubanCodeIvaTercerMes,
    } = useThubanDocs();

    const hasBackupData = documentationBackup?.documentDataList?.length > 0;
    const { getBackupDataByStepId } = useHistoricData(hasBackupData);

    useEffect(() => {
        if (documentationRequestStatus === "SUCCESS") {
            dispatch(
                environmentActions.setDocumentationRequest({
                    status: "INITIAL",
                    value: "",
                    error: null,
                }),
            );
            dispatch(push("/environment/stepFinish"));
        } else if (documentationRequestStatus === "FAILURE") {
            // !=COR000I
            dispatch(push("/environment/stepError"));
            return;
            setError(documentationRequestError);
            dispatch(modalActions.modalShow());
        }
    }, [documentationRequestStatus, documentationRequestError]);

    const submitIsAllowed = ({ values }) => {
        const { documentEstatutoContrato, documentCertificacionVentasCierre } = values;

        const firstFieldsAreValid = !!documentEstatutoContrato && !!documentCertificacionVentasCierre;

        return firstFieldsAreValid;
    };

    const onHeaderBack = () => {
        getBackupDataByStepId("stepBeneficiaries");
        dispatch(replace("/environment/stepBeneficiaries"));
    };

    const getDocumentData = (values) => {
        const documentsUploaded = [
            {
                documentType: thubanCodeEstatuto,
                documentID: values.documentEstatutoContrato,
                documentKey: "documentEstatutoContrato",
            },
            {
                documentType: thubanCodeModificacionesEstatuto,
                documentID: values.documentModificacionesEstatutoContrato,
                documentKey: "documentModificacionesEstatutoContrato",
            },
            {
                documentType: thubanCodeActasDesignacion,
                documentID: values.documentActaDesignacionAutoridades,
                documentKey: "documentActaDesignacionAutoridades",
            },
            {
                documentType: thubanCodeActasDistribucion,
                documentID: values.documentActaDistribucion,
                documentKey: "documentActaDistribucion",
            },
            {
                documentType: thubanCodeBalanceActual,
                documentID: values.documentBalanceActual,
                documentKey: "documentBalanceActual",
            },
            {
                documentType: thubanCodeBalanceAnterior,
                documentID: values.documentBalanceAnterior,
                documentKey: "documentBalanceAnterior",
            },
            {
                documentType: thubanCodeActasGobiernoActual,
                documentID: values.documentActasGobiernoActual,
                documentKey: "documentActasGobiernoActual",
            },
            {
                documentType: thubanCodeActasGobiernoAnterior,
                documentID: values.documentActasGobiernoAnterior,
                documentKey: "documentActasGobiernoAnterior",
            },
            {
                documentType: thubanCodeVentas,
                documentID: values.documentCertificacionVentasCierre,
                documentKey: "documentCertificacionVentasCierre",
            },
            {
                documentType: thubanCodeIvaMesActual,
                documentID: values.documentIVAMesActual,
                documentKey: "documentIVAMesActual",
            },
            {
                documentType: thubanCodeIvaSegundoMes,
                documentID: values.documentIVASegundoMes,
                documentKey: "documentIVASegundoMes",
            },
            {
                documentType: thubanCodeIvaTercerMes,
                documentID: values.documentIVATercerMes,
                documentKey: "documentIVATercerMes",
            },
            {
                documentType: "",
                documentID: values.documentEstatutoContratoName,
                documentKey: "documentEstatutoContratoName",
            },
            {
                documentType: "",
                documentID: values.documentModificacionesEstatutoContratoName,
                documentKey: "documentModificacionesEstatutoContratoName",
            },
            {
                documentType: "",
                documentID: values.documentActaDesignacionAutoridadesName,
                documentKey: "documentActaDesignacionAutoridadesName",
            },
            {
                documentType: "",
                documentID: values.documentActaDistribucionName,
                documentKey: "documentActaDistribucionName",
            },
            {
                documentType: "",
                documentID: values.documentBalanceActualName,
                documentKey: "documentBalanceActualName",
            },
            {
                documentType: "",
                documentID: values.documentBalanceAnteriorName,
                documentKey: "documentBalanceAnteriorName",
            },
            {
                documentType: "",
                documentID: values.documentActasGobiernoActualName,
                documentKey: "documentActasGobiernoActualName",
            },
            {
                documentType: "",
                documentID: values.documentActasGobiernoAnteriorName,
                documentKey: "documentActasGobiernoAnteriorName",
            },
            {
                documentType: "",
                documentID: values.documentCertificacionVentasCierreName,
                documentKey: "documentCertificacionVentasCierreName",
            },
            {
                documentType: "",
                documentID: values.documentIVAMesActualName,
                documentKey: "documentIVAMesActualName",
            },
            {
                documentType: "",
                documentID: values.documentIVASegundoMesName,
                documentKey: "documentIVASegundoMesName",
            },
            {
                documentType: "",
                documentID: values.documentIVATercerMesName,
                documentKey: "documentIVATercerMesName",
            },
        ];
        return documentsUploaded;
    };

    const getDataDocument = () => {
        const historicDocuments = {};

        if (!documentationBackup?.documentDataList?.length) {
            return historicDocuments;
        }

        documentationBackup.documentDataList.forEach((item) => {
            const { documentKey } = item;
            const { documentID } = item;
            historicDocuments[documentKey] = documentID[0];
        });

        return historicDocuments;
    };

    const requiredString = i18nUtils.get("forms.inputFile.massivePayments.invalid.required");
    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            documentEstatutoContrato: "",
            documentEstatutoContratoName: "",
            documentModificacionesEstatutoContrato: "",
            documentModificacionesEstatutoContratoName: "",
            documentActaDesignacionAutoridades: "",
            documentActaDesignacionAutoridadesName: "",
            documentActaDistribucion: "",
            documentActaDistribucionName: "",
            documentBalanceActual: "",
            documentBalanceActualName: "",
            documentBalanceAnterior: "",
            documentBalanceAnteriorName: "",
            documentActasGobiernoActual: "",
            documentActasGobiernoActualName: "",
            documentActasGobiernoAnterior: "",
            documentActasGobiernoAnteriorName: "",
            documentCertificacionVentasCierre: "",
            documentCertificacionVentasCierreName: "",
            documentIVAMesActual: "",
            documentIVAMesActualName: "",
            documentIVASegundoMes: "",
            documentIVASegundoMesName: "",
            documentIVATercerMes: "",
            documentIVATercerMesName: "",
            ...getDataDocument(),
        },
        validationSchema: () =>
            Yup.object().shape({
                documentEstatutoContrato: Yup.string().required(requiredString),
                documentModificacionesEstatutoContrato: Yup.string(),
                documentActaDesignacionAutoridades: Yup.string(),
                documentActaDistribucion: Yup.string(),
                documentBalanceActual: Yup.string(),
                documentBalanceAnterior: Yup.string(),
                documentActasGobiernoActual: Yup.string(),
                documentActasGobiernoAnterior: Yup.string(),
                documentCertificacionVentasCierre: Yup.string().required(requiredString),
                documentIVAMesActual: Yup.string(),
                documentIVASegundoMes: Yup.string(),
                documentIVATercerMes: Yup.string(),
            }),
        onSubmit: (values) => {
            if (values) {
                const finalValues = {
                    documentEstatutoContrato: values?.documentEstatutoContrato,
                    documentEstatutoContratoName: values?.documentEstatutoContratoName,
                    documentModificacionesEstatutoContrato: values?.documentModificacionesEstatutoContrato,
                    documentModificacionesEstatutoContratoName: values?.documentModificacionesEstatutoContratoName,
                    documentActaDesignacionAutoridades: values?.documentActaDesignacionAutoridades,
                    documentActaDesignacionAutoridadesName: values?.documentActaDesignacionAutoridadesName,
                    documentActaDistribucion: values?.documentActaDistribucion,
                    documentActaDistribucionName: values?.documentActaDistribucionName,
                    documentBalanceActual: values?.documentBalanceActual,
                    documentBalanceActualName: values?.documentBalanceActualName,
                    documentBalanceAnterior: values?.documentBalanceAnterior,
                    documentBalanceAnteriorName: values?.documentBalanceAnteriorName,
                    documentActasGobiernoActual: values?.documentActasGobiernoActual,
                    documentActasGobiernoActualName: values?.documentActasGobiernoActualName,
                    documentActasGobiernoAnterior: values?.documentActasGobiernoAnterior,
                    documentActasGobiernoAnteriorName: values?.documentActasGobiernoAnteriorName,
                    documentCertificacionVentasCierre: values?.documentCertificacionVentasCierre,
                    documentCertificacionVentasCierreName: values?.documentCertificacionVentasCierreName,
                    documentIVAMesActual: values?.documentIVAMesActual,
                    documentIVAMesActualName: values?.documentIVAMesActualName,
                    documentIVASegundoMes: values?.documentIVASegundoMes,
                    documentIVASegundoMesName: values?.documentIVASegundoMesName,
                    documentIVATercerMes: values?.documentIVATercerMes,
                    documentIVATercerMesName: values?.documentIVATercerMesName,
                };
                dispatch(environmentActions.setDocumentationBackup(getDocumentData(finalValues)));
                dispatch(environmentActions.saveDocumentation(getDocumentData(finalValues)));
            }
        },
    };

    return (
        <>
            {isMobile ? (
                <Head
                    titleText={i18nUtils.get("legalPerson.title", "Registro")}
                    onBack={onHeaderBack}
                    hideNavbarInMobile
                    showCenterContent
                    tooltipMobile
                    onClickTooltip={() => setHelpIsVisible(true)}
                    tooltipImage={isIOS ? "images/figma/icon/help-white.svg" : "images/figma/icon/help.svg"}
                />
            ) : (
                <HeaderSimple inverse />
            )}
            <MainContainer className="onboarding" showLoader={fetching}>
                <EnvironmentStepper isMobile={isMobile} page="StepDocumentation" />
                <div className="step">
                    {!isMobile && (
                        <Head
                            titleText={i18nUtils.get("", "Documentación de tu empresa")}
                            onBack={onHeaderBack}
                            tooltip
                            showCenterContent
                            onClickTooltip={() => setHelpIsVisible(true)}
                            tooltipImage="images/figma/icon/help.svg"
                        />
                    )}
                    {isMobile && (
                        <I18n
                            id="environment.documentation.title"
                            defaultValue="Documentación de tu empresa"
                            component="h1"
                        />
                    )}
                    <Formik {...formikProps}>
                        {(allFormik) => (
                            <Form>
                                <div className="grid-table grid-table-form">
                                    <div className="grid-table-row grid-cols-12">
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Documentación de la sociedad:" component="h2" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Estatuto o contrato social (obligatorio)" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentEstatutoContrato"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeEstatuto}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentEstatutoContrato,
                                                    documentName: getDataDocument()?.documentEstatutoContratoName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Modificaciones de estatuto o contrato social (opcional)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentModificacionesEstatutoContrato"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeModificacionesEstatuto}
                                                defaultDocument={{
                                                    documentId: getDataDocument()
                                                        ?.documentModificacionesEstatutoContrato,
                                                    documentName: getDataDocument()
                                                        ?.documentModificacionesEstatutoContratoName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Actas de designacion de las autoridades (opcional)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentActaDesignacionAutoridades"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeActasDesignacion}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentActaDesignacionAutoridades,
                                                    documentName: getDataDocument()
                                                        ?.documentActaDesignacionAutoridadesName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Actas de distribución de cargos (opcional)" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentActaDistribucion"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeActasDistribucion}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentActaDistribucion,
                                                    documentName: getDataDocument()?.documentActaDistribucionName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Documentación contable" component="h2" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Balance actual (opcional)" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentBalanceActual"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeBalanceActual}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentBalanceActual,
                                                    documentName: getDataDocument()?.documentBalanceActualName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Balance de año anterior (opcional)" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentBalanceAnterior"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeBalanceAnterior}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentBalanceAnterior,
                                                    documentName: getDataDocument()?.documentBalanceAnteriorName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Acta del órgano de gobierno con aprobación del Balance actual (opcional)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentActasGobiernoActual"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeActasGobiernoActual}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentActasGobiernoActual,
                                                    documentName: getDataDocument()?.documentActasGobiernoActualName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Acta del órgano de gobierno con aprobación del Balance de año anterior (opcional)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentActasGobiernoAnterior"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeActasGobiernoAnterior}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentActasGobiernoAnterior,
                                                    documentName: getDataDocument()?.documentActasGobiernoAnteriorName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Ventas post cierre de balance y/o del ejercicio (obligatorio)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentCertificacionVentasCierre"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeVentas}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentCertificacionVentasCierre,
                                                    documentName: getDataDocument()
                                                        ?.documentCertificacionVentasCierreName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Si tu empresa no posee balance" component="h2" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n
                                                id=""
                                                defaultValue="Últimas 3 (tres) posiciones mensuales de IVA (opcional)"
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Mes actual" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentIVAMesActual"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeIvaMesActual}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentIVAMesActual,
                                                    documentName: getDataDocument()?.documentIVAMesActualName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Segundo mes" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentIVASegundoMes"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeIvaSegundoMes}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentIVASegundoMes,
                                                    documentName: getDataDocument()?.documentIVASegundoMesName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <I18n id="" defaultValue="Tercer mes" />
                                        </div>
                                        <div className="grid-table-data col-start-2 col-span-10">
                                            <Field
                                                component={Uploader}
                                                idForm={FORM_ID}
                                                name="documentIVATercerMes"
                                                label="Adjuntá documentación"
                                                extensionDocument="pdf"
                                                documentCode={thubanCodeIvaTercerMes}
                                                defaultDocument={{
                                                    documentId: getDataDocument()?.documentIVATercerMes,
                                                    documentName: getDataDocument()?.documentIVATercerMesName,
                                                }}
                                                withDocumentName
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ paddingBottom: "30px" }} />
                                <div className="grid-table form-actions">
                                    <div className="grid-table-row sm:flex md:grid-cols-12">
                                        <div className="grid-table-data md:col-start-5 md:col-span-4">
                                            <Button
                                                bsStyle="primary"
                                                label="global.continue"
                                                loading={documentationRequestStatus === "FETCHING"}
                                                type="submit"
                                                block
                                                disabled={!submitIsAllowed(allFormik)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </MainContainer>

            <EnvironmentHelpSlide
                slideIsVisible={helpIsVisible}
                closeSlide={() => setHelpIsVisible(false)}
                isMobile={isMobile}
                page={PAGE_ID}
            />

            <ErrorPopup error={error} handleClick={() => dispatch(modalActions.modalClose())} />
        </>
    );
};

StepDocumentation.propTypes = {
    isMobile: bool.isRequired,
    documentationBackup: arrayOf(shape({})).isRequired,
    documentationRequest: arrayOf(shape({})).isRequired,
    fetching: bool.isRequired,
};

const mapStateToProps = (state) => ({
    documentationBackup: environmentSelectors.getDocumentationBackup(state),
    documentationRequest: environmentSelectors.getDocumentationRequest(state),
    fetching: environmentSelectors.getFetching(state),
});

export default connect(mapStateToProps)(StepDocumentation);
